var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.onBodyClick}},[_c('v-head',{attrs:{"flag":_vm.flag}}),_c('div',{staticClass:"content"},[_c('router-view',{staticClass:"router-view"}),_c('v-foot')],1),(_vm.showScrollToTop)?_c('div',{staticClass:"scroll-to-top",on:{"click":_vm.toTop}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }